<template>
    <div>
        <div class="mb-3">
            <label class="form-label">Items (uno por linea)</label>
            <textarea class="form-control" rows="4" :value="itemsText"
                @input="updateItems($event.target.value)"></textarea>
        </div>
        <div class="form-check mb-3">
            <input class="form-check-input" type="checkbox" :checked="modelValue.ordered"
                @change="update('ordered', $event.target.checked)" id="listOrdered">
            <label class="form-check-label" for="listOrdered">Lista ordenada</label>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Estilo de marcador</label>
                <select class="form-select" :value="modelValue.listStyleType"
                    @change="update('listStyleType', $event.target.value)">
                    <option value="disc">disc</option>
                    <option value="circle">circle</option>
                    <option value="square">square</option>
                    <option value="decimal">decimal</option>
                    <option value="decimal-leading-zero">decimal-leading-zero</option>
                    <option value="lower-roman">lower-roman</option>
                    <option value="upper-roman">upper-roman</option>
                    <option value="lower-alpha">lower-alpha</option>
                    <option value="upper-alpha">upper-alpha</option>
                    <option value="lower-greek">lower-greek</option>
                    <option value="lower-latin">lower-latin</option>
                    <option value="upper-latin">upper-latin</option>
                    <option value="armenian">armenian</option>
                    <option value="georgian">georgian</option>
                    <option value="none">none</option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Posicion del marcador</label>
                <select class="form-select" :value="modelValue.listStylePosition"
                    @change="update('listStylePosition', $event.target.value)">
                    <option value="outside">Outside</option>
                    <option value="inside">Inside</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Color</label>
                <div class="d-flex gap-2 align-items-center">
                    <input class="form-control" type="text" :value="modelValue.color"
                        @input="update('color', $event.target.value)">
                    <input class="form-control form-control-color" type="color"
                        :value="modelValue.color || '#111827'"
                        @input="update('color', $event.target.value)">
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Font size</label>
                <input class="form-control" type="text" :value="modelValue.fontSize"
                    @input="update('fontSize', $event.target.value)">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Font family</label>
                <input class="form-control" type="text" :value="modelValue.fontFamily"
                    @input="update('fontFamily', $event.target.value)">
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Line height</label>
                <input class="form-control" type="text" :value="modelValue.lineHeight"
                    @input="update('lineHeight', $event.target.value)">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Alineacion</label>
                <select class="form-select" :value="modelValue.align" @change="update('align', $event.target.value)">
                    <option value="left">Izquierda</option>
                    <option value="center">Centro</option>
                    <option value="right">Derecha</option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Padding</label>
                <input class="form-control" type="text" :value="modelValue.padding"
                    @input="update('padding', $event.target.value)">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MailingBlockListEditor',
    props: {
        modelValue: { type: Object, default: () => ({}) },
    },
    emits: ['update:modelValue'],
    computed: {
        itemsText() {
            return Array.isArray(this.modelValue.items) ? this.modelValue.items.join('\n') : '';
        },
    },
    methods: {
        update(key, value) {
            this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
        },
        updateItems(value) {
            const items = value
                .split('\n')
                .map((item) => item.trim())
                .filter((item) => item.length > 0);
            this.update('items', items);
        },
    },
};
</script>
